import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, LogOut, Loader } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { COMMITTEE_EMAIL } from '../lib/committee';
import './PendingApproval.css';

/**
 * What someone sees once a new owner or tenant has taken over their address.
 *
 * Their account and everything they filed is kept — it simply no longer opens
 * the resident features, and the committee's address is right there if the
 * change was a mistake or they have moved somewhere else in Forest Town.
 */
export function MovedOut() {
    const { user, signOut } = useAuth();
    const navigate = useNavigate();
    const [signingOut, setSigningOut] = useState(false);

    const handleSignOut = async () => {
        setSigningOut(true);
        try {
            await signOut();
            navigate('/', { replace: true });
        } finally {
            setSigningOut(false);
        }
    };

    return (
        <div className="pending-page">
            <div className="pending-container animate-fade-in">
                <div className="pending-icon"><Home size={48} /></div>

                <h1>This account has been marked as moved out</h1>

                <p className="pending-message">
                    The committee's records show someone else is now registered at your old address, so this account no
                    longer opens the resident pages. Nothing you posted has been deleted.
                </p>

                <div className="pending-info card">
                    <div className="info-row">
                        <Home size={20} aria-hidden="true" />
                        <div>
                            <strong>Still living in Forest Town?</strong>
                            <p>
                                Email the committee at <a href={`mailto:${COMMITTEE_EMAIL}`}>{COMMITTEE_EMAIL}</a> with your new
                                address and they'll move your account across. If this was a mistake, tell them and they'll put it back.
                            </p>
                        </div>
                    </div>
                </div>

                {user?.email && <p className="pending-email">Signed in as <strong>{user.email}</strong></p>}

                <button type="button" className="btn btn-secondary" onClick={handleSignOut} disabled={signingOut}>
                    {signingOut ? <Loader className="spinner-icon" size={18} /> : <LogOut size={18} />}
                    Sign out
                </button>

                <p className="pending-privacy">
                    <Link to="/privacy">Privacy Notice</Link>
                </p>
            </div>
        </div>
    );
}
